module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/danaspirit-bkg-f4b74ca0790a3044c36c73507f8f8ad2.jpg";